export default __webpack_public_path__ + "static/media/turkey.8e5384ae.webp";